export default __webpack_public_path__ + "static/media/Alexanderplatz_1.d69b417a.jpg";